import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import Avatar from "./Avatar";
import FormattedPhone from "./FormattedPhone";
import Footer from "./Footer";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

import {
	Card,
	CardContent,
	CardActions,
	Typography,
	Button,
	makeStyles
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	card: {
		minWidth: 250,
		boxShadow: "none",
		paddingBottom: theme.spacing(2),
		backgroundColor: theme.palette.primary.grey
	},

	title: {
		fontWeight: "bold"
	},

	content: {
		marginTop: 15,
		paddingBottom: 0
	},

	name: {
		marginTop: theme.spacing(1.25)
	},

	typography: {
		color: theme.palette.primary.black
	},

	jobTitle: {
		fontSize: "0.8rem"
	},

	actions: {
		justifyContent: "center",
		flexDirection: "column"
	},

	avatarWrapper: {
		display: "flex",
		justifyContent: "center"
	},

	button: {
		width: "80%",
		textTransform: "none",
		marginLeft: "0px !important",
		marginTop: theme.spacing(1)
	},

	footer: {
		backgroundColor: theme.palette.primary.grey
	}
}));

function SupportContact(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);

	let classes = styles(),
		{csm, closeHandler, history} = props,
		{name, title, landline, email, avatar} = csm,
		phone = landline;

	return (
		<React.Fragment>
			{csm ?
				<Card className={`${classes.card}`}>
					<CardContent className={classes.content}>
						<React.Fragment>
							<div className={classes.avatarWrapper}>
								<Avatar
									sizeFactor={2}
									authorName={name}
									authorImage={avatar} />
							</div>
							<Typography
								align="center"
								className={`${classes.typography} ${classes.name}`}>{name}</Typography>
							<Typography
								align="center"
								className={`${classes.typography} ${classes.jobTitle}`}>{title || "Client Support"}</Typography>
						</React.Fragment>
					</CardContent>
					<CardActions className={classes.actions}>
						{email ?
							<Button
								variant="contained"
								color="primary"
								href={`mailto:${email}`}
								onClick={closeHandler}
								className={classes.button}>Send An Email</Button> : null
						}
						{phone ?
							<Button
								variant="contained"
								color="primary"
								href={`tel:${phone}`}
								onClick={closeHandler}
								className={classes.button}>
								Call&nbsp;<FormattedPhone number={phone} />
							</Button> : null
						}
					</CardActions>
				</Card>
				: null
			}
			<Footer
				history={history}
				closeHandler={closeHandler}
				className={classes.footer} />
		</React.Fragment>
	);
}

SupportContact.propTypes = {
	csm: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	closeHandler: PropTypes.func
};

export default SupportContact;
